var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProfileAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1615_96414)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1615_96414",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1615_96414)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1615_96414",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1615_96414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2968 7.46387C13.2968 8.11572 13.1031 8.75292 12.741 9.29492C12.3788 9.83692 11.8646 10.2597 11.2623 10.5091C10.6601 10.7586 9.99735 10.8235 9.35802 10.6963C8.71869 10.5691 8.13113 10.2555 7.6702 9.7946C7.20927 9.33367 6.89568 8.7461 6.76851 8.10677C6.64134 7.46744 6.70623 6.80471 6.95568 6.20247C7.20513 5.60024 7.62788 5.08513 8.16987 4.72298C8.71187 4.36083 9.34907 4.16797 10.0009 4.16797C10.4337 4.16797 10.8625 4.25299 11.2623 4.41862C11.6622 4.58425 12.0256 4.82709 12.3317 5.13314C12.6377 5.43918 12.8805 5.80261 13.0462 6.20247C13.2118 6.60234 13.2968 7.03105 13.2968 7.46387Z",
    fill: "#9196AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4347 10.543C13.0025 11.0262 12.473 11.4128 11.8812 11.6774C11.2893 11.9421 10.6488 12.0778 10.0005 12.0778C9.35218 12.0778 8.71081 11.9421 8.11898 11.6774C7.52714 11.4128 6.99768 11.0262 6.56543 10.543C5.79302 11.0904 5.16282 11.8147 4.72786 12.6556C4.29291 13.4965 4.06587 14.4286 4.06543 15.3753C4.06543 15.5501 4.13468 15.7188 4.2583 15.8424C4.38192 15.9661 4.54979 16.0345 4.72461 16.0345H15.2723C15.4471 16.0345 15.615 15.9661 15.7386 15.8424C15.8622 15.7188 15.9315 15.5501 15.9315 15.3753C15.9314 14.4289 15.7042 13.4965 15.2699 12.6556C14.8355 11.8147 14.2065 11.0908 13.4347 10.543Z",
    fill: "#9196AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05706 10.082C5.30013 9.84744 5.56196 9.63316 5.84075 9.44238C5.73603 9.23292 5.65045 9.01602 5.5844 8.79134C5.45295 8.36197 5.38613 7.91388 5.38665 7.46484C5.38527 6.56808 5.64628 5.69104 6.13697 4.94043C5.89384 4.86634 5.64081 4.82863 5.38665 4.82812C4.71911 4.83225 4.07837 5.08919 3.59303 5.54753C3.10769 6.00586 2.8142 6.63099 2.7719 7.2972C2.7296 7.96341 2.94169 8.62198 3.36516 9.13802C3.78864 9.65406 4.39214 9.99026 5.0538 10.0788L5.05706 10.082Z",
    fill: "#9196AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43856 10.1061C2.39336 10.0586 2.35208 10.0066 2.31405 9.95312C1.56209 10.6236 1.0504 11.523 0.857341 12.5117C0.821476 12.6966 0.826926 12.8859 0.873617 13.0684C0.920308 13.2508 1.00644 13.4215 1.12671 13.5664C1.25153 13.7185 1.40872 13.8402 1.58651 13.9245C1.7643 14.0088 1.9586 14.0527 2.15536 14.0531H2.86743C3.05538 13.0215 3.46982 12.0455 4.08081 11.1934C3.45091 10.9745 2.88572 10.6008 2.43856 10.1061Z",
    fill: "#9196AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4172 8.79036C14.3511 9.01503 14.2655 9.23193 14.1608 9.44141C14.4396 9.63217 14.7014 9.84646 14.9445 10.0811C15.6062 9.99254 16.2097 9.65634 16.6331 9.1403C17.0566 8.62426 17.2687 7.96732 17.2264 7.30111C17.1841 6.6349 16.8906 6.00977 16.4053 5.55143C15.9199 5.0931 15.2792 4.83616 14.6117 4.83203C14.3575 4.83254 14.1045 4.87025 13.8613 4.94434C14.352 5.69494 14.613 6.57198 14.6117 7.46875C14.6122 7.91779 14.5454 8.36425 14.4139 8.79362L14.4172 8.79036Z",
    fill: "#9196AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1436 12.5101C18.9505 11.5213 18.4388 10.6236 17.6868 9.95312C17.6477 10.0056 17.608 10.0521 17.5688 10.098C17.1203 10.5956 16.5537 10.9716 15.9209 11.1917C16.5319 12.0439 16.9455 13.0215 17.1335 14.0531H17.8455C18.0423 14.0527 18.2366 14.0088 18.4144 13.9245C18.5922 13.8402 18.7494 13.7169 18.8742 13.5648C18.9944 13.4198 19.0806 13.2508 19.1273 13.0684C19.174 12.8859 19.1794 12.695 19.1436 12.5101Z",
    fill: "#9196AF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1615_96414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileAbout);
export default __webpack_public_path__ + "static/media/icon-profile-about.18e70644ed6280d2a93d1b064a53ecbc.svg";
export { ForwardRef as ReactComponent };